/**
 * English practice words, written for this tool. Common short words first so a
 * home-row-only lesson still has real words to offer, then longer and office words.
 * Lessons filter this to words typeable with the keys unlocked so far.
 */
const WORDS = `
a an and the to of in it is as at be by he we or on do if so no up my me us an
all any can day did for get got had has her him his how its let man may new not
now off old one our out own put say she the too two use was way who you and are
but can for had her his how man new now old one our out see the too two use way
able back ball base bank bird blue body book both call came care case city come
cost dark data date deal does done door down draw drop each easy else even ever
face fact fall farm feel feet fell felt find fine fire fish five food foot form
four free from full game gave give goes gold gone good gray grew hair half hand
hard have head hear heat held help here high hold home hope hour idea into iron
item join jump just keep kept kind knew know land last late lead left less life
like line list live long look lose lost love made make many mark mean meet mind
mine miss more most move much must name near need next nice none note okay once
only open over page pair part pass past path plan play plus poor pull push rain
read real rest rich ride ring rise road rock role room rule safe said same save
seat seem seen self sell send sent ship shop show side sign site size slow snow
some song soon sort spot star stay step stop such sure take talk team tell term
test than that them then they this thus time tiny told took tool town tree true
turn unit upon used user very view wait wake walk wall want warm wash week well
went were west what when whom wide wife will wind wine wish with word work year
about above after again below bring build chair child class clean clear close
could court cover doing early earth every field first floor force found front
given glass great green group guide heart house human large learn least leave
level light local maybe might money month music never night north offer often
order other paper party peace phone piece place plant point power price proof
quick quiet quite reach ready right river round scale scene sense serve seven
shall shape share short sixth skill small smart solid sound south space speak
speed spend stand start state still stone store study style sugar table teach
thank their there these thing think third those three today total touch trade
train tried under until usual value visit voice watch water where which while
white whole whose woman women world would write wrong young above office letter
notice report office public service matter nation income policy result member
market system future student teacher program project subject history science
example section general natural special reason simple method change growth
`;

export const ENGLISH_WORDS = Array.from(new Set(WORDS.split(/\s+/).map((w) => w.trim()).filter(Boolean)));
